import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import SEO from "../components/SEO";

const About = () => {
  return (
    <Layout>
      <SEO
        title="Bekah June"
        description="Engineer, founder, and writer building at the intersection of technology and human connection."
        type="website"
        url="/"
        image="/photo1.JPG"
        imageAlt="Bekah June"
        keywords={["Bekah June", "startup founder", "software engineer", "GitHub Actions", "developer tools", "tech writer"]}
      />

      <div className="layout pb-[4.5rem]">
        <article className="max-w-2xl mx-auto font-system text-[#000000]">
          <header className="mb-10 md:mt-6">
            <h1 className="text-[24px] sm:text-[28px] md:text-[32px] font-semibold leading-[1.2] tracking-tight text-[#000000]">
              Welcome to my corner of the internet!
            </h1>
          </header>

          <figure className="mb-12">
            <img
              src="/photo16.jpg"
              alt="Bekah June"
              className="w-full max-w-md mx-auto h-auto rounded-lg"
              loading="eager"
            />
          </figure>

          <p className="my-6 leading-[1.7] text-lg">
            Like any good story, let's start at the beginning…
          </p>

          <p className="my-6 leading-[1.7] text-lg">
            I was born in Kharkiv, Ukraine and adopted when I was three. This has shaped my
            identity over the years in different ways and I'm deeply proud to say I'm
            Ukrainian. I'm also Italian, which was a more recent discovery as I learned about
            my biological father.
          </p>

          <figure className="my-10">
            <div className="grid grid-cols-2 gap-2">
              <img
                src="/photo1.JPG"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
              <img
                src="/photo2.jpg"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
            </div>
          </figure>

          <p className="my-6 leading-[1.7] text-lg">
            I have always been a deeply curious person and started making things at a very
            young age. At 10 years old I started my own handmade card business. They ended up
            being sold at our local boutique in town!
          </p>

          <figure className="my-10">
            <div className="grid grid-cols-3 gap-2">
              <img
                src="/IMG_0018.PNG"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
              <img
                src="/IMG_0050.jpeg"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
              <img
                src="/IMG_0025.jpeg"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
            </div>
          </figure>

          <p className="my-6 leading-[1.7] text-lg">
            I've had different blogs over the years as technology's home for words has
            shifted, but this is where you can find all my recent essays.
          </p>

          <p className="my-6 leading-[1.7] text-lg">
            Work-wise I've been an engineer, product leader, and most recently a founder.
            Outside of work I paint, write fiction, build apps, read a lot, play chess, and go
            to the movies. I also walk a lot. No really, a lot.
          </p>

          <figure className="my-10">
            <div className="grid grid-cols-3 gap-2">
              <img
                src="/000167770021.jpeg"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
              <img
                src="/photo9.JPG"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
              <img
                src="/888BEA12-DE62-4EF0-87C2-86EEE1A20A9D_1_105_c.jpeg"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
              <img
                src="/178A2889-B1E0-404F-BA9E-FB13E5820CFC_4_5005_c.jpeg"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
              <img
                src="/photo15.jpg"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
              <img
                src="/FE3A1A14-D91F-4893-AA63-6098072F97D6_1_201_a.jpeg"
                alt=""
                className="w-full aspect-square object-cover rounded-md"
                loading="lazy"
              />
            </div>
          </figure>

          <p className="my-6 leading-[1.7] text-lg">
            If there's anything else you'd like to know about me, don't hesitate to{" "}
            <Link
              to="/contact"
              className="text-[#000000] underline underline-offset-2 hover:text-[#000000]/70 transition-colors"
            >
              say hello
            </Link>
            !
          </p>
        </article>
      </div>
    </Layout>
  );
};

export default About;
